module.exports = __webpack_public_path__ + "static/logo-4da53b3f66e047787721a56aeb028b69.svg";